import React from "react";
import image from "../../src/Assets/registration-banner.png"; // Webpack/CRA will resolve this

const ThankYouPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: `url(${image}) no-repeat center center`,
        backgroundSize: "cover", 
        flexDirection: "column",
        backgroundAttachment: "fixed",
        padding: 0,  
        width: "100%",
         overflow: "hidden",
      }}
    >
      <div
        style={{
          background: "#f8ede6",
          borderRadius: "15px",
          boxShadow: "0 4px 32px #0001",
          padding: "40px 32px 40px 32px",
          maxWidth: "900px",
          width: "100%",
          textAlign: "left",
        }}
      >
        <h1 style={{
          fontSize: "30px",
          fontWeight: 700,
          marginBottom: "18px",
          color: "#222",
          textAlign: "center"
        }}>
          <span role="img" aria-label="celebrate">🎉</span> Thank You for Your Payment! <span role="img" aria-label="celebrate">🎉</span>
        </h1>
        <p style={{ fontSize: "16px", color: "#333", marginBottom: 12 }}>
          We appreciate your trust in us. Your payment is being processed, and we will confirm it within <strong>24 hours</strong>.
        </p>
        <p style={{ fontSize: "16px", color: "#333", marginBottom: 24 }}>
          Once confirmed, <strong>your bot file</strong> will be delivered to you via email.
        </p>
        <div style={{ margin: "18px 0", borderTop: "1px solid #e0d6ce", paddingTop: 18 }}>
          <div style={{ display: "flex", alignItems: "flex-start", marginBottom: 16 }}>
            <span style={{ fontSize: "20px", marginRight: 12 }}>📩</span>
            <div>
              <span style={{ fontWeight: 600, color: "#222", fontSize: "16px" }}>Can't find the email?</span>
              <div style={{ color: "#555", fontSize: "13px" }}>
                No worries! Sometimes it sneaks into the Spam or Promotions folder — be sure to check there too.
              </div>
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "flex-start" }}>
            <span style={{ fontSize: "20px", marginRight: 12 }}>💬</span>
            <div>
              <span style={{ fontWeight: 600, color: "#222", fontSize: "14px" }}>Need a hand?</span>
              <div style={{ color: "#555", fontSize: "13px" }}>
                We're just an email away at <a href="mailto:pipgridsocial@gmail.com" style={{ color: "#222", fontWeight: 600, textDecoration: "underline", fontSize: "15px" }}>pipgridsocial@gmail.com</a> — and we'd love to help.
              </div>
            </div>
          </div>
        </div>
        <p style={{ fontSize: "18px", fontWeight: 600, color: "#222", marginTop: 30 }}>
          Thank you for&nbsp;choosing&nbsp;us!&nbsp;<span role="img" aria-label="rocket">🚀</span>
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;
